export default __webpack_public_path__ + "static/media/Profile.a436c23a.png";